import axios from 'axios';
import { authHeader, getToken } from '../utils/tokenUtils';

const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

const multipartHeader = () => ({
    headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'multipart/form-data' }
});

export const getActiveBanners = () => axios.get(`${BASE_URL}/banners`);
export const getAllBanners = () => axios.get(`${BASE_URL}/banners/admin/all`, authHeader());
export const createBanner = (formData) => axios.post(`${BASE_URL}/banners`, formData, multipartHeader());
export const updateBanner = (id, formData) => axios.put(`${BASE_URL}/banners/${id}`, formData, multipartHeader());
export const deleteBanner = (id) => axios.delete(`${BASE_URL}/banners/${id}`, authHeader());